export const carouselExtensionType = 'com.atlassian.confluence.carousel';
export const carouselExtensionKey = 'carousel';
export const carouselContentAnalyticSource = 'carouselExtension';
export const carouselConfigAnalyticSource = 'carouselExtensionConfig';
